import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface SearchBarProps extends React.FormHTMLAttributes<HTMLFormElement> {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  handleSearch: (e: React.FormEvent) => void;
}

const SearchBar = ({ searchQuery, setSearchQuery, handleSearch, className, ...formProps }: SearchBarProps) => {
  const { t } = useTranslation('explore');

  return (
    <form {...formProps} onSubmit={handleSearch} className={cn("max-w-3xl", className)}>
      <div className="relative">
        <input 
          type="text" 
          placeholder={t("searchPlaceholder")}
          className="w-full rounded-md border border-white/20 bg-white px-5 py-3.5 pr-16 text-brand-ink shadow-lg placeholder:text-brand-slate focus:border-brand-ink focus:outline-none focus:ring-2 focus:ring-white/40 sm:pr-28"
          value={searchQuery} 
          onChange={e => setSearchQuery(e.target.value)} 
        />
        <button 
          type="submit" 
          className="absolute bottom-1.5 right-1.5 top-1.5 inline-flex items-center justify-center gap-2 rounded-md bg-brand-ink px-4 text-sm font-medium text-white transition-colors hover:bg-brand-charcoal sm:px-5"
        >
          <Search className="h-5 w-5" />
          <span className="hidden sm:inline">Search</span>
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
